var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.siteClass,attrs:{"id":"app"}},[(_vm.siteClass)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }